var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.building)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.building))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.room))])]):_c('span',[_vm._v(_vm._s(_vm.room))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d85a872","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/RoomNumber.vue
// module id = 657
// module chunks = 0 1